import {Text} from "@pg-design/text-module";
import {Country, OfferType} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";
import {preLineDescription} from "../../utils/pre_line_description";
import {HomematchPropertyCardDetailOfferInfoDescriptionGenerated} from "./HomematchPropertyCardDetailOfferInfoDescriptionGenerated";

import * as styles from "./HomematchPropertyCardDetailOfferInfoDescription.module.css";

interface IProps {
    offer: IOffer;
    region: {
        country: Country;
        name_declension_where: string;
    };
    type: OfferType;
}

export const HomematchPropertyCardDetailOfferInfoDescription = (props: IProps) => {
    const {offer, region, type} = props;

    const hasDescription = Boolean(offer.description);
    const shouldShowGeneratedDescription = !hasDescription || offer.show_generated_description;

    return (
        <Text as="div" className={styles.offerDescription} variant="body_copy_1">
            {hasDescription && <div>{preLineDescription(offer.description)}</div>}

            {shouldShowGeneratedDescription && <HomematchPropertyCardDetailOfferInfoDescriptionGenerated offer={offer} region={region} type={type} />}
        </Text>
    );
};
import {Text} from "@pg-design/text-module";
import {Country, OfferType} from "@pg-rp/common-types";

import {IOffer} from "../../types/property/IOffer";
import {preLineDescription} from "../../utils/pre_line_description";
import {HomematchPropertyCardDetailOfferInfoDescriptionGenerated} from "./HomematchPropertyCardDetailOfferInfoDescriptionGenerated";

import * as styles from "./HomematchPropertyCardDetailOfferInfoDescription.module.css";

interface IProps {
    offer: IOffer;
    region: {
        country: Country;
        name_declension_where: string;
    };
    type: OfferType;
}

export const HomematchPropertyCardDetailOfferInfoDescription = (props: IProps) => {
    const {offer, region, type} = props;

    const hasDescription = Boolean(offer.description);
    const shouldShowGeneratedDescription = !hasDescription || offer.show_generated_description;

    return (
        <Text as="div" className={styles.offerDescription} variant="body_copy_1">
            {hasDescription && <div>{preLineDescription(offer.description)}</div>}

            {shouldShowGeneratedDescription && <HomematchPropertyCardDetailOfferInfoDescriptionGenerated offer={offer} region={region} type={type} />}
        </Text>
    );
};
